import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';

const options = [
  {
    type: 'CLIENT',
    emoji: '🚀',
    title: 'I need services',
    subtitle: 'Hire freelancers, agencies & creative studios',
    features: ['Post projects', 'Book studios by the hour', 'Direct messaging', 'Secure payments']
  },
  {
    type: 'PROVIDER',
    emoji: '💼',
    title: 'I offer services',
    subtitle: 'Sell your skills, list your studio',
    features: ['Create service listings', 'Manage bookings', 'Get paid securely', 'Build your portfolio']
  }
];

export default function OnboardingPage() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);

  const handleContinue = () => {
    if (selected) navigate('/auth', { state: { accountType: selected, mode: 'register' } });
  };

  return (
    <div className="min-h-screen bg-dark-bg flex flex-col px-6 py-10">
      <div className="mb-8">
        <Logo size="sm" />
      </div>

      <div className="flex-1">
        <h1 className="text-3xl font-bold text-dark-text mb-2" style={{ letterSpacing: '-0.5px' }}>
          How will you use Findr?
        </h1>
        <p className="text-dark-subtext mb-8">Choose your account type to get started.</p>

        <div className="flex flex-col gap-4">
          {options.map(opt => (
            <button
              key={opt.type}
              onClick={() => setSelected(opt.type)}
              className={`w-full text-left p-5 rounded-2xl border-2 transition-all ${
                selected === opt.type
                  ? 'border-brand-purple bg-brand-purple/10 glow'
                  : 'border-dark-border bg-dark-surface'
              }`}
            >
              <div className="flex items-start gap-4">
                <span className="text-3xl">{opt.emoji}</span>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="font-bold text-dark-text text-lg">{opt.title}</h3>
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                      selected === opt.type ? 'border-brand-purple bg-brand-purple' : 'border-dark-muted'
                    }`}>
                      {selected === opt.type && <div className="w-2 h-2 rounded-full bg-white" />}
                    </div>
                  </div>
                  <p className="text-dark-subtext text-sm mb-3">{opt.subtitle}</p>
                  <div className="flex flex-col gap-1">
                    {opt.features.map(f => (
                      <div key={f} className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-brand-purple" />
                        <span className="text-xs text-dark-subtext">{f}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      <button
        onClick={handleContinue}
        disabled={!selected}
        className={`w-full py-4 rounded-2xl font-semibold text-base mt-6 transition-all ${
          selected ? 'bg-brand-gradient text-white glow' : 'bg-dark-surface text-dark-subtext cursor-not-allowed'
        }`}
      >
        Continue
      </button>
    </div>
  );
}
